export enum ToolVersionState {
  DRAFT = 'new',
  ENABLED = 'on',
  DISABLED = 'off',
}
